/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch';

import v from './validators';
import { ListaUrzedow } from '../urzad/ListaUrzedow';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

const LandDevelDict = {
  LocalColor: {
    label: 'Kolor oznaczenia lokalizacji',
    editable: true,
  },
  LineColor: {
    label: 'Kolor inwestycji liniowych',
    editable: true,
  },
  BoundColor: {
    label: 'Kolor granicy terenu inwestycji',
    editable: true,
  },
  PolygonColor: {
    label: 'Kolor obszaru oddziaływania inwestycji',
    editable: true,
  }
};

const LinearDict = {
  OccupationWidth: {
    label: 'Szerokość zajętego pasa',
    editable: true,
    type: "number",
  },
  OccupationArea: {
    label: 'Powierzchnia zajęta',
    editable: true,
    type: "number",
  },
};

const IntendedBuildTypeDict = {
  BuildTypeName: {
    label: 'Nazwa zamierzenia budowlanego',
    editable: true,
  },
  BuildTypeType: {
    label: 'Rodzaj zamierzenia budowlanego',
    editable: true,
  },
};

const OtherDict = {
  OtherFlatAmount: {
    label: 'W przypadku realizacji budynku mieszkalnego należy podać liczbę mieszkań',
    editable: true,
    type: "number",
  },
  OtherAreaSelling: {
    label: 'W przypadku realizacji obiektu handlowego należy podać w m2 przewidywaną powierzchnię sprzedażową (tj. część budynku przeznaczoną do obsługi nabywców, bez tzw. zaplecza, które należy rozumieć magazyny, biura, komunikację, pomieszczenia socjalne i inne pomieszczenia pomocnicze)',
    editable: true,
    type: "number",
  },
};

const PlannedBuildCharacteristics = {
  BuildArea: {
    label: 'Powierzchnia zabudowy budynku',
    editable: true,
    type: "number",
  },
  BuildVolume: {
    label: 'Kubatura',
    editable: true,
    type: "number",
  },
  BuildLevels: {
    label: 'Liczba kondygnacji',
    editable: true,
    type: "number",
  },
  BuildHeight: {
    label: 'Wysokość obiektu',
    editable: true,
    type: "number",
  },
  FrontElevationWidth: {
    label: 'Szerokość elewacji frontowej',
    editable: true,
    type: "number",
  },
  TangentWithParceNo: {
    label: 'Zabudowa styczna do granicy działki nr',
    editable: true,
    type: "number",
  },
};

const RoofCharacteristics = {
  RoofType: {
    label: 'Rodzaj dachu',
    editable: true,
  },
  RoofAngle: {
    label: 'Kąt nachylenia połaci dachowych',
    editable: true,
    type: "number",
  },
  RoofRidgeHeight: {
    label: 'Wysokość kalenicy od średniego poziomu terenu przed  wejściem do budynku',
    editable: true,
    type: "number",
  },
  RoofCorniceHeight: {
    label: 'Wysokość gzymsu lub attyki',
    editable: true,
    type: "number",
  },
  RoofConstrType: {
    label: 'Rodzaj konstrukcji dachowej',
    editable: true,
  },
  TypeOfRoofing: {
    label: 'Rodzaj pokrycia dachowego',
    editable: true,
  },
  HouseCount: {
    label: 'Liczba mieszkań',
    editable: true,
    type: "number",
  },
  SalesSurface: {
    label: 'Powierzchnia sprzedażowa',
    editable: true,
    type: "number",
  },
};

const InfrastructureNeeds = {
  Water: { label: 'Woda: ', editable: true },
  Energy: { label: 'Energia elektryczna: ', editable: true },
  Gas: { label: 'Gaz: ', editable: true },
  Sewege: { label: 'Odprowadzanie i oczyszczenie ścieków', editable: true },
  Heat: {
    label: 'Sposób ogrzewania obiektów kubaturowych (podać rodzaj czynnika grzewczego)',
    editable: true,
  },
  Other: { label: 'Inne potrzeby', editable: true },
};

const OtherInfo = {
  ParkingCount: {
    label: 'Przewidywana liczba miejsc parkingowych: ',
    editable: true,
    type: "number",
  },
  ParkingArea: {
    label: 'Przewidywana powierzchnia dróg i parkingów: ',
    editable: true,
    type: "number",
  },
  ParkingBiolArea: {
    label: 'Przewidywana powierzchnia biologicznie czynna',
    editable: true,
    type: "number",
  },
};

const InvestAreaInfo = {
  InvestGreenery: {
    label:
      'Występowanie zieleni wysokiej i średniej (w szczególności przewidzianych przez inwestora drzew do wycinki lub przesadzenia)',
    editable: true,
  },
  InvestGroundNetwork: {
    label:
      'Występowanie sieci uzbrojenia (w szczególności przewidzianych przez inwestora do likwidacji lub przebudowy)',
    editable: true,
  },
  InvestBuildings: {
    label:
      'Występowanie budynków, budowli usytuowanych na terenie inwestycji (w szczególności przewidzianych przez inwestora do rozbiórki lub przebudowy)',
    editable: true,
  },
  CurrentInvestAreaUse: {
    label: 'Obecne wykorzystanie terenu inwestycji i budynków na nim się znajdujących',
    editable: true,
  },
};

class DecyzjeWZ extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
    },
    BuildType: {
      BuildTypeName: null,
      BuildTypeType: null,
    },
    LandDevelop: {
      LocalColor: null,
      LineColor: null,
      BoundColor: null,
      PolygonColor: null,
      OccupationWidth: null,
      OccupationArea: null,
    },
    PlannedBuildCharacteristics: {
      BuildArea: null,
      BuildVolume: null,
      BuildLevels: null,
      BuildHeight: null,
      FrontElevationWidth: null,
      TangentWithParceNo: null,
      RoofType: null,
      RoofAngle: null,
      RoofRidgeHeight: null,
      RoofCorniceHeight: null,
      RoofConstrType: null,
      TypeOfRoofing: null,
      HouseCount: null,
      SalesSurface: null,
    },
    OtherBuildCharacteristics: {
      OtherParams: null,
    },
    InfrastructureNeeds: {
      Water: null,
      Energy: null,
      Gas: null,
      Sewege: null,
      Heat: null,
      Other: null,
    },
    OtherAmounts: {
      OtherFlatAmount: null,
      OtherAreaSelling: null
    },
    OtherInfo: {
      ParkingCount: null,
      ParkingArea: null,
      ParkingBiolArea: null,
    },
    InvestAreaInfo: {
      InvestGreenery: null,
      InvestGroundNetwork: null,
      InvestBuildings: null,
      CurrentInvestAreaUse: null,
    },
    OwnershipInfo: {
      InvestOwnership: null,
      ParcelOwnership: null,
    },
    RoadInfo: {
      AccessToArea: null,
      ExitToPublicRoad: null,
    },
    MorgageInfo: {
      MorgageBurdens: null,
    },
    FarmInfo: {
      BasicFarmInfo: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull, v.MinLength(2)],
    AddressStreet: [v.NotNull],
    AddressFlat: [v.NotNull],
    AddressNumber: [v.NotNull],
    BuildTypeName: [v.NotNull],
    BuildTypeType: [v.NotNull],
    LocalColor: [v.NotNull],
    LineColor: [v.NotNull],
    BoundColor: [v.NotNull],
    PolygonColor: [v.NotNull],
    OccupationWidth: [v.NotNull],
    OccupationArea: [v.NotNull],
    BuildArea: [v.NotNull],
    BuildVolume: [v.NotNull],
    BuildLevels: [v.NotNull],
    BuildHeight: [v.NotNull],
    FrontElevationWidth: [v.NotNull],
    TangentWithParceNo: [v.NotNull],
    RoofType: [v.NotNull],
    RoofAngle: [v.NotNull],
    RoofRidgeHeight: [v.NotNull],
    RoofCorniceHeight: [v.NotNull],
    RoofConstrType: [v.NotNull],
    TypeOfRoofing: [v.NotNull],
    HouseCount: [v.NotNull],
    SalesSurface: [v.NotNull],
    OtherParams: [v.NotNull],
    Water: [v.NotNull],
    Energy: [v.NotNull],
    Gas: [v.NotNull],
    Sewege: [v.NotNull],
    Heat: [v.NotNull],
    Other: [v.NotNull],
    ParkingCount: [v.NotNull],
    ParkingArea: [v.NotNull],
    ParkingBiolArea: [v.NotNull],
    InvestGreenery: [v.NotNull],
    InvestGroundNetwork: [v.NotNull],
    InvestBuildings: [v.NotNull],
    CurrentInvestAreaUse: [v.NotNull],
    InvestOwnership: [v.NotNull],
    ParcelOwnership: [v.NotNull],
    AccessToArea: [v.NotNull],
    ExitToPublicRoad: [v.NotNull],
    MorgageBurdens: [v.NotNull],
    BasicFarmInfo: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {

        this.setState({
          eserviceDistrict: resp
        })
      })
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  getLandDevelExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Planowana lokalizacja projektowanego zamierzenia została oznaczona na załączonej do wniosku
      kopii mapy zasadniczej (jednym egzemplarzu) linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'LocalColor')}. <br />
      <br />
      Przewidywany przebieg projektowanych inwestycji liniowych (sieci uzbrojenia, drogi) oznaczono na
      mapie zasadniczej linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'LineColor')}.<br />
      <br />
      Granice terenu inwestycji oznaczono na mapie linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'BoundColor')}.<br />
      <br />
      Obszar na który inwestycja będzie oddziaływać oznaczono na mapie linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'PolygonColor')}.<br />
      <br />
    </p>
  );

  getLinearExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      W przypadku realizacji inwestycji liniowej podać przewidywaną do czasowego zajęcia szerokości pasa
      terenu wzdłuż projektowanej sieci: {' '} {this.render_info('LandDevelop', 'OccupationWidth')}, ewentualnie
      wielkość terenu niezbędnego dla zajęcia pod budynki tymczasowe (np. pas terenu dla ruchu ciężkich samochodów i maszyn
      budowlanych, place dla składowania materiałów i lokalizację barakowozów):
      {this.render_info('LandDevelop', 'OccupationArea')} m<sup>2</sup>.
    </p>
  )

  getIntendedBuildTypeExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      tj. rodzaj planowanych robót budowlanych (np. budowa/wykonanie a także odbudowa, rozbudowa,
      nadbudowa, obiektu budowlanego/, lub prace polegające na przebudowie , montażu, remoncie lub
      rozbiórce obiektu budowlanego oraz zmiana sposobu użytkowania obiektu budowlanego lub jego
      części) oraz funkcja i sposób zagospodarowania terenu inwestycji (np. budynek: mieszkalny,
      jednorodzinny, wielorodzinny, usługowy, handlowy, gospodarczy, garaż):
    </p>
  );

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["DecisionData", "BuildType", "LandDevelop",
        "PlannedBuildCharacteristics", "OtherBuildCharacteristics",
        "InfrastructureNeeds", "OtherInfo", "InvestAreaInfo", "OtherAmounts",
        "OwnershipInfo",
        "MorgageInfo",
        "RoadInfo",
        "FarmInfo",];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'Warszawa',
        AddressStreet: 'Koncertowa',
        AddressFlat: 9,
        AddressNumber: 6,
        AddressZipCode: '02-787',
      },
      BuildType: {
        BuildTypeName: 'testowy',
        BuildTypeType: 'testowy',
      },
      LandDevelop: {
        LocalColor: "red",
        LineColor: "Blue",
        OccupationWidth: 123.12,
        OccupationArea: 123.32,
      },
      PlannedBuildCharacteristics: {
        BuildArea: 213.12,
        BuildVolume: 213.11,
        BuildLevels: 3,
        BuildHeight: 22,
        FrontElevationWidth: 33,
        TangentWithParceNo: 11,
        RoofType: "Stromy",
        RoofAngle: 23,
        RoofRidgeHeight: 22,
        RoofCorniceHeight: 22,
        RoofConstrType: "taki tam typ koonstrukcji",
        TypeOfRoofing: "aaaaa",
        HouseCount: 1,
        SalesSurface: 323.32,
      },
      OtherBuildCharacteristics: {
        OtherParams: "to powinien być text",
      },
      InfrastructureNeeds: {
        Water: "jest",
        Energy: "bendzie",
        Gas: "do sasiada za plot",
        Sewege: "jesttt",
        Heat: "ni ma",
        Other: "asdfsdf",
      },
      OtherInfo: {
        ParkingCount: 1,
        ParkingArea: 21.35,
        ParkingBiolArea: 35.3333,
      },
      OtherAmounts: {
        OtherFlatAmount: 2,
        OtherAreaSelling: 32,
      },
      InvestAreaInfo: {
        InvestGreenery: "trzy drzewa klon",
        InvestGroundNetwork: "brak uzbrojenia",
        InvestBuildings: "brak",
        CurrentInvestAreaUse: "brak",
      },
      OwnershipInfo: {
        InvestOwnership: "Krzysztof Gregorowicz",
        ParcelOwnership: "Krzysztof Gregorowicz",
      },
      RoadInfo: {
        AccessToArea: "Działka znajduje się prz drodze publicznej",
        ExitToPublicRoad: "Tak",
      },
      MorgageInfo: {
        MorgageBurdens: "brak",
      },
      FarmInfo: {
        BasicFarmInfo: "brak obciążenia",
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          BuildType: { ...this.state.BuildType },
          LandDevelop: { ...this.state.LandDevelop },
          PlannedBuildCharacteristics: { ...this.state.PlannedBuildCharacteristics },
          OtherBuildCharacteristics: { ...this.state.OtherBuildCharacteristics },
          InfrastructureNeeds: { ...this.state.InfrastructureNeeds },
          OtherInfo: { ...this.state.OtherInfo },
          OtherAmounts: { ...this.state.OtherAmounts },
          InvestAreaInfo: { ...this.state.InvestAreaInfo },
          OwnershipInfo: { ...this.state.OwnershipInfo },
          MorgageInfo: { ...this.state.MorgageInfo },
          RoadInfo: { ...this.state.RoadInfo },
          FarmInfo: { ...this.state.FarmInfo },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix]
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        {this.props.district === "205011" ?
          <h4 style={{ textAlign: 'justify', color: 'red', marginLeft: '15px', marginRight: '15px' }}>
            Uwaga! Ze względu na pełne pokrycie gminy miejscowymi planami
            zagospodarowania przestrzennego informujemy, że Urząd nie rozpatruje
            wniosków ws. wydania decyzji o warunkach zabudowy oraz wniosków ws.
            ustalenia lokalizacji inwestycji celu publicznego. Prosimy o składanie
            wniosków ws. wydania wypisu i wyrysu z miejscowego planu zagospodarowania
            przestrzennego.
        </h4> : null
        }

        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </DecisionContainer>

        <DecisionContainer
          title={'2. Rodzaj zamierzenia inwestycyjnego'}
          data={this.state.BuildType}
          errors={this.state.errors}
          explain_text={() => this.getIntendedBuildTypeExplain()}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          formDict={IntendedBuildTypeDict}
          onChange={e => this.onChange(e, 'BuildType')}
        />

        <DecisionContainer
          title={'3. Charakterystyka planowanej budowy'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getLandDevelExplain()}
          formDict={LandDevelDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <DecisionContainer
          title={'4. W przypadku inwestycji liniowej'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getLinearExplain()}
          formDict={LinearDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <DecisionContainer
          title={'5. Charakterystyka planowanej zabudowy'}
          data={this.state.PlannedBuildCharacteristics}
          errors={this.state.errors}
          formDict={PlannedBuildCharacteristics}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'PlannedBuildCharacteristics')}
        />

        <DecisionContainer
          title={'6. Dach'}
          data={this.state.PlannedBuildCharacteristics}
          errors={this.state.errors}
          formDict={RoofCharacteristics}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'PlannedBuildCharacteristics')}
        />

        <DecisionContainer
          title={'7. Inne'}
          data={this.state.OtherAmounts}
          errors={this.state.errors}
          formDict={OtherDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'OtherAmounts')}
        />

        <GrayPanel title={'8. Charakterystyczne parametry techniczne projektowanej  inwestycji '}>
          {this.getTextAreaWithError(
            `Informacje zawierające dane na temat charakterystycznych etapów realizacji
            planowanej inwestycji budowy, rodzaj technologii i procesów związanych z przewidywaną
            działalnością gospodarczą oraz w przypadku braku obowiązku przeprowadzania postępowania
            w sprawie oceny oddziaływania na środowisko, dane charakteryzujące jej wpływ na
            środowisko np. emisja pyłów, gazów, zapachów, hałasu oraz promieniowania:`,
            "OtherBuildCharacteristics",
            "OtherParams"
          )}
        </GrayPanel>

        <DecisionContainer
          title={'9. Potrzeby inwestycji w zakresie infrastruktury technicznej'}
          data={this.state.InfrastructureNeeds}
          errors={this.state.errors}
          formDict={InfrastructureNeeds}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'InfrastructureNeeds')}
        />

        <DecisionContainer
          title={'10. Inne istotne informacje na temat inwestycji'}
          data={this.state.OtherInfo}
          errors={this.state.errors}
          formDict={OtherInfo}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'OtherInfo')}
        />

        <DecisionContainer
          title={'11. Dane o terenie inwestycji'}
          data={this.state.InvestAreaInfo}
          errors={this.state.errors}
          formDict={InvestAreaInfo}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'InvestAreaInfo')}
        />

        <GrayPanel title={'12. Dane dotyczące własności:'}>
          {this.getTextAreaWithError(
            'Dane dotyczące własności terenu inwestycji:',
            'OwnershipInfo',
            'InvestOwnership'
          )
          }
          {this.getTextAreaWithError(
            'Dane dotyczące własności działek, na które inwestycja będzie oddziaływać na dzień składania wniosku: ',
            'OwnershipInfo',
            'ParcelOwnership'
          )
          }
        </GrayPanel>

        <GrayPanel title={'13. Określenie dostępu do drogi publicznej: '}>
          {this.getInputWithError(
            'Obsługa komunikacyjna-dojazd do terenu odbywał się będzie:',
            'RoadInfo',
            'AccessToArea'
          )
          }
          {this.getInputWithError(
            'Zjazd na drogę publiczną:',
            'RoadInfo',
            'ExitToPublicRoad'
          )
          }
        </GrayPanel>

        <GrayPanel
          title={
            '14. W przypadku realizacji zagrody rolnej lub uzupełniania zagrody o nowe obiekty:'
          }
        >

          {this.getTextAreaWithError(
            `Dane dotyczące posiadanego przez inwestora gospodarstwa rolnego:`,
            'FarmInfo',
            'BasicFarmInfo',
          )}
        </GrayPanel>

        <GrayPanel
          title={
            '15. Podać czy teren inwestycji jest obciążony hipotecznie lub zwyczajowo na rzecz innych działek: '
          }
        >
          {this.getTextAreaWithError(
            'Numery działek i rodzaj obciążenia:',
            'MorgageInfo',
            'MorgageBurdens',
          )}
        </GrayPanel>

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p>Do wniosku o wydanie decyzji należy załączyć, w uzgodnieniu z organem właściwym do wydania decyzji:</p>
              <ul>
                <li>Wyrys z mapy ewidencyjnej gruntów wraz z wypisem (2 egzemplarze w tym może być 1 kserokopia)</li>
                <li>Wykaz władających działkami sąsiednimi/wokół działki planowanej do zainwestowania</li>
                <li>Kopię mapy zasadniczej w skali 1:5000 lub 1:1000 (dla inwestycji liniowych dopuszczalna skala 1:2000) - 2 egzemplarze - przyjęta do państwowego zasobu geodezyjnego i kartograficznego obejmująca teren, którego wniosek dotyczy i obsza na który inwestycja będzie oddziaływać (trzykrotna szerokość frontu działki objętej wnioskiem, nie mniejsza jendka niż 50 metrów z każdej strony działki, w przypadku nowej zabudowy i zagospodarowania terenu)</li>
                <li>Umowy zawarte miedzy właściwą jednostką organizacyjną a inwestorem, gwarantujące wykonanie uzbrojenia terenu inwestycji, (zapewnienie dostawy wody, odbioru ścieków, dostawy energii elektrycznej)</li>
                <li>Pełnomocnictwo w razie ustawienia osoby do występowania w imieniu inwestora</li>
                <li>Dokument potwierdzający posiadanie gospodarstwa rolnego (w przypadku występowania o wydanie decyzji dla zabudowy zagrodowej)</li>
                <li>Decyzja o środowiskowych uwarunkowaniach realizacji przedsięwzięcia (zgodnie z ustawą z dnia 3 października 2008r. - o udostępnianiu informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz o ocenach oddziaływania na środowisko /Dz. U. z 2008r. Nr 199, poz. 1227/).</li>
              </ul>
            </div>
          </div>
        </GrayPanel>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjeWZ.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjeWZ),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjeWZ.js